import React from 'react';
import { Container } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import LoginPanel from '../components/LoginPanel';

function HomePage() {
  const { currentUser } = useAuth();

  return (
    <div>
      <Container className="text-center mt-3">
        <h1>Welcome to the Hardy Fleet Portal!</h1>
        <img
          src={require('../assets/full-logo.png')}
          alt="Full Logo"
        />
        <h6>(770) 445-6655</h6>
      </Container>

      {!currentUser && (
        <Container className="d-flex align-items-center justify-content-center mt-3">
          <LoginPanel showHeading={false} />
        </Container>
      )}
    </div>
  );
}

export default HomePage;
